import DayHeading from '~/components/forms/questions/scheduling/DayHeading.jsx';
import HeadingPreviousNext from '~/components/forms/questions/scheduling/HeadingPreviousNext.jsx';
import {
    addDays,
    format,
    isSameDay,
    isSameMonth,
    startOfMonth,
} from 'date-fns';
import useWeekStart from '~/lib/useWeekStart.js';
import MonthlyAvailabilityMiniCal from '~/components/forms/questions/scheduling/MonthlyAvailabilityMiniCal.jsx';
import { useState } from 'react';

const ClassMonthlyDayNavigation = ({
    start,
    end,
    selectedDate,
    setSelectedDate,
    classes,
    onPrevious,
    onNext,
    setViewStart,
}) => {
    const [view, setView] = useState();
    const [viewActiveDate, setViewActiveDate] = useState();

    const weekStart = useWeekStart();
    const month = startOfMonth(start);
    const monthlyCalendar = [];
    const monthlyViewStart = new Date(month);
    monthlyViewStart.setDate(1 - monthlyViewStart.getDay() + weekStart);
    if (monthlyViewStart > month) {
        monthlyViewStart.setDate(monthlyViewStart.getDate() - 7);
    }

    // Create calendar grid (6 weeks to ensure we cover the month)
    for (let week = 0; week < 6; week++) {
        let weekdays = [];
        for (let dow = 0; dow < 7; dow++) {
            weekdays.push(addDays(monthlyViewStart, week * 7 + dow));
        }

        if (
            isSameMonth(weekdays[0], month) ||
            isSameMonth(weekdays[6], month)
        ) {
            monthlyCalendar.push(weekdays);
        }
    }

    function hasClasses(date) {
        for (let c of classes) {
            if (isSameDay(new Date(c.start), date)) {
                return true;
            }
        }

        return false;
    }

    const canGoBack = start > new Date();

    return (
        <div className="monthly-minical-container availability-picker">
            <HeadingPreviousNext
                className="mb-2"
                onPrevious={() => canGoBack && onPrevious()}
                onNext={onNext}
                start={start}
                end={end}
            >
                {format(start, 'LLLL yyyy')}
            </HeadingPreviousNext>
            <div className="bg-white rounded-lg">
                <MonthlyAvailabilityMiniCal
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    canSelectAnyDate={false}
                    tileDisabled={({ activeStartDate, date, view }) => {
                        if (view !== 'month') {
                            return;
                        }
                        return !hasClasses(date);
                    }}
                    setView={setView}
                    viewActiveDate={viewActiveDate}
                    updateActiveStart={date => {
                        setViewStart(date);
                        setViewActiveDate(date);
                    }}
                />
            </div>
        </div>
    );
};

export default ClassMonthlyDayNavigation;
